import React, { useMemo } from "react";
import { INewsDisplay } from "api/types/NewsEntity";
import { equalWithin, unionBy } from "helpers/globalFunctions";
import { definedRouteTypes } from "api/api";

import ClusterMap from "../../molecules/Maps/ClusterMap";

import { COORDINATES_ARE_EQUAL_WITHIN } from "constants/important";

interface CardMapProps {
  events: INewsDisplay[];
  defaultZoom?: number;
  getUserLocation?: boolean;
}

const MarkerMap: React.FC<CardMapProps> = ({
  events,
  defaultZoom,
  getUserLocation,
}) => {
  const { pathname } = window.location;
  const loadMarkers = useMemo(() => {
    if (events === undefined) return [];

    let markers = events.filter(
      (event) =>
        event.address?.geolocation.lat && event.address?.geolocation.lng,
    );

    markers.forEach((marker) => {
      const dupes = markers.filter(
        (possibleDupe) =>
          equalWithin(
            possibleDupe.address?.geolocation.lat,
            marker.address?.geolocation.lat,
            COORDINATES_ARE_EQUAL_WITHIN,
          ) &&
          equalWithin(
            possibleDupe.address?.geolocation.lng,
            marker.address?.geolocation.lng,
            COORDINATES_ARE_EQUAL_WITHIN,
          ) &&
          marker.id !== possibleDupe.id,
      );

      if (dupes.length !== 0) {
        const a = 360.0 / dupes.length;

        dupes.forEach((dupe, i) => {
          if (!dupe.address) return;
          // eslint-disable-next-line no-param-reassign
          dupe.address.geolocation.lat +=
            -0.001 * Math.cos(((a * i) / 180) * Math.PI);
          // eslint-disable-next-line no-param-reassign
          dupe.address.geolocation.lng +=
            -0.001 * Math.sin(((a * i) / 180) * Math.PI);
        });

        markers = unionBy(markers, dupes, "id");
      }
    });
    return markers;
  }, [events]);

  return (
    <div>
      <ClusterMap
        markers={loadMarkers}
        freeZoom={pathname.includes(definedRouteTypes.latviansAroundWorld)}
        defaultZoom={defaultZoom}
        getUserLocation={getUserLocation}
      />
    </div>
  );
};

export default MarkerMap;
